<template>
    <div v-if="labelVisible" class="font-bold pb-2 text-sm" :class="labelClass">{{ field_name }}<span
        v-show="required" class="text-next-orange"> *</span>
    </div>
    <slot>
        <input v-if="type==='date'" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
               type="date" v-bind="inputAttrs"
               class="p-7px bg-next-gray-md-dark hover:bg-white w-full">

        <input v-else :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" :type="type"
               :placeholder="placeholder === undefined ? field_name : placeholder" v-bind="inputAttrs"
               class="p-2 bg-next-gray-md-dark hover:bg-white w-full">
    </slot>
    <slot name="help"></slot>
    <slot name="errors">
        <small v-for="(e,i) in errors" :key="i"
               class="text-next-orange">{{ e }}</small>
    </slot>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'Field',
    emits: ['update:modelValue','click'],
    props: {
        field_name: {
            type: String,
            default: 'Field'
        },
        labelVisible: {
            type: Boolean,
            default: true
        },
        labelClass: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: undefined
        },
        errors: {
            type: Array,
            default: []
        },
        modelValue: {
            type: [String, Number, Object],
            default: undefined
        },
        inputAttrs: {
            type: Object,
            default: {}
        },
        required: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text'
        }
    }
})
export default class Field extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
